export const TRANSLATE_NAMESPACE = 'navbar';

export default {
  TRANSLATE_NAMESPACE,
};
